import { PaymentMethod } from '@lucidtech/las-sdk-browser';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useSessionStorage } from '@uidotdev/usehooks';
import { memo, ReactNode, useMemo } from 'react';

import { useOrganizationStore } from '@/store';
import { getPendingPaymentMethodKey } from '@/utils';

export type StripePaymentProps = {
  children?: ReactNode;
};

const IStripePayment = ({ children }: StripePaymentProps) => {
  const organizationId = useOrganizationStore((state) => state.organizationId);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [paymentMethod, _] = useSessionStorage<PaymentMethod | undefined>(
    getPendingPaymentMethodKey(organizationId),
    undefined
  );

  const stripePromise = useMemo(() => {
    if (paymentMethod?.stripePublishableKey) {
      return loadStripe(paymentMethod.stripePublishableKey);
    }
    return null;
  }, [paymentMethod]);

  const options = useMemo(() => {
    if (paymentMethod?.stripeSetupIntentSecret) {
      return { clientSecret: paymentMethod.stripeSetupIntentSecret };
    }
  }, [paymentMethod]);

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export const StripePayment = memo(IStripePayment) as typeof IStripePayment;
